import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Importiere alle Sektionen
import ContentSection from './ContentSection';

// Registriere die Übersetzungen
import translations from './translations';
import { registerTranslations } from '@/hooks/useTranslation';

// Registriere die Übersetzungen für diese Seite
registerTranslations('notFoundPage', translations);

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return <ContentSection />;
};

export default NotFound; 